import React from "react";
import {
  ModalOverlay,
  ModalCouponContent,
  ModalTitle,
  CouponCloseButton,
} from '../styles'

const InstantSuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalCouponContent>
        <ModalTitle>Agendamento realizado com sucesso!</ModalTitle>
        <CouponCloseButton onClick={onClose}>Fechar</CouponCloseButton>
      </ModalCouponContent>
    </ModalOverlay>
  );
};

export default InstantSuccessModal;
